import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-4 col-12" }
const _hoisted_5 = { class: "col-md-2 col-12" }
const _hoisted_6 = { class: "col-md-2 col-12" }
const _hoisted_7 = { class: "col-md-2 col-12" }
const _hoisted_8 = { class: "col-md-2 col-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12 div-table-retornos" }
const _hoisted_11 = { class: "table table-striped table-hover table-sm table-bordered" }
const _hoisted_12 = { class: "col-md-12 text-center table-danger" }
const _hoisted_13 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_14 = { class: "d-inline" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = {
  class: "text-center",
  "data-label": "Opções"
}
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = { class: "card-footer" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = { class: "col-md-1" }

import { onMounted, reactive, } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { fdataHora } from "@/utils/funcoes";

//componentes
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Loading from "@/components/Loading/index.vue"
import RetornoStatus from "./RetornoStatus.vue"
import Pergunta from "@/components/Pergunta/Index.vue"
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue"
import Paginador from "@/components/Paginador/Index.vue"
import ImportarRetorno from "./ImportarRetorno.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Retornos',
  setup(__props) {


//vue
var controle = reactive({
    filtros: {
        paginaAtual: 1,
        tamanhoPagina: 50
    } as service.BoletoRetornosFiltros,
    retornos: [] as service.BoletoRetorno[],
    retornoId: 0 as number,
    retorno: {} as service.BoletoRetorno,
    ordemDirecao: "Desc",
    ordemColuna: "RetornoId",
    totalRegistros: 0,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,
    retornoParaProcessar: null as service.BoletoRetorno | null,

    janImportarRetorno: false,

});


onMounted(() => {
    pesquisar();
})


const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.retornos = [] as service.BoletoRetorno[];
    controle.totalRegistros = 0;

    if (controle.filtros.dataCadIni == "")
        controle.filtros.dataCadIni = null;

    if (controle.filtros.dataCadFin == "")
        controle.filtros.dataCadFin = null;

    service.obterRetornos(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.retornos = r.dados;
            controle.totalRegistros = r.totalRegistros;
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};



const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.retornos = controle.retornos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.retornos = controle.retornos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

// Função para mostrar confirmação antes de processar retorno
function perguntaProcessar(retorno: service.BoletoRetorno) {
    controle.retornoParaProcessar = retorno;
    controle.showConfirmDialog = true;
}

// Função chamada quando o usuário responde ao diálogo
function confirmaProcessar(confirmou: boolean) {
    controle.showConfirmDialog = false;

    if (confirmou && controle.retornoParaProcessar) {
        processarRetorno(controle.retornoParaProcessar);
    }

    controle.retornoParaProcessar = null;
}

// Função para processar o retorno
async function processarRetorno(retorno: service.BoletoRetorno) {
    try {
        controle.loading = true;
        controle.processandoRetorno = true;
        controle.status = "Processando retorno...";

        // Aqui você chamaria o serviço para processar o retorno
        await service.processarRetorno(retorno.retornoId);

        // Simular processamento por 2 segundos
        await new Promise(resolve => setTimeout(resolve, 2000));

        controle.status = "Retorno processado com sucesso!";

        pesquisar();

        setTimeout(() => {
            controle.loading = false;
            controle.processandoRetorno = false;
        }, 3000);


    } catch (erro) {
        controle.erro = `Erro ao processar retorno: ${erro}`;
    } finally {
        controle.processandoRetorno = false;
        setTimeout(() => {
            controle.status = "";
            controle.loading = false;
        }, 3000);
    }
}


return (_ctx: any,_cache: any) => {
  const _component_NavBarStatus = _resolveComponent("NavBarStatus")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBarStatus, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = ''))
    }, null, 8, ["erro"]),
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(BreadCrumb, {
      PageTitle: "Retornos",
      items: [{label: 'Inicio', to: '/'}, {label: 'Boletos', to: '/boletos'}, {label: 'Retornos', to: '/retornos'}]
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Convênio", -1)),
            _createVNode(DropdownParamBoleto, {
              modelValue: _unref(controle).filtros.paramBoletoId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.paramBoletoId) = $event)),
              id: "inputFocus",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (pesquisar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Data Inicial", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.dataCadIni) = $event)),
              type: "date",
              class: "form-control form-control-sm",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (pesquisar()))
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.dataCadIni]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Data Final", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).filtros.dataCadFin) = $event)),
              type: "date",
              class: "form-control form-control-sm",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (pesquisar()))
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.dataCadFin]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).filtros.status) = $event)),
              class: "form-select form-select-sm",
              onChange: _cache[8] || (_cache[8] = ($event: any) => (pesquisar()))
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("option", { value: null }, "- Todos -", -1),
              _createElementVNode("option", { value: 0 }, "Pendente", -1),
              _createElementVNode("option", { value: 1 }, "Em Processamento", -1),
              _createElementVNode("option", { value: 2 }, "Concluído", -1),
              _createElementVNode("option", { value: 3 }, "Erro", -1)
            ]))], 544), [
              [_vModelSelect, _unref(controle).filtros.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm mt-3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (pesquisar()))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("i", { class: "fa fa-search" }, null, -1),
              _createTextVNode(" Pesquisar ", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _cache[25] || (_cache[25] = _createElementVNode("thead", { class: "th-fixed" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "text-end" }, "Retorno"),
                  _createElementVNode("th", { class: "text-center" }, "Data"),
                  _createElementVNode("th", { class: "text-start" }, "Cedente"),
                  _createElementVNode("th", { class: "text-start" }, "Cnpj"),
                  _createElementVNode("th", { class: "text-end" }, "Número"),
                  _createElementVNode("th", { class: "text-end" }, "Nº arquivo"),
                  _createElementVNode("th", { class: "text-end" }, "Qtde itens"),
                  _createElementVNode("th", { class: "text-center" }, "Status"),
                  _createElementVNode("th", { class: "text-center" }, "Opções")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _withDirectives(_createElementVNode("tr", null, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("td", {
                    colspan: "15",
                    class: "text-center"
                  }, [
                    _createElementVNode("div", { class: "d-inline" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-spin" }),
                      _createTextVNode(" Pesquisando... ")
                    ])
                  ], -1)
                ]))], 512), [
                  [_vShow, _unref(controle).pesquisando == true]
                ]),
                _withDirectives(_createElementVNode("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                    ]),
                    _createElementVNode("a", {
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (pesquisar()))
                    }, "Repetir")
                  ])
                ], 512), [
                  [_vShow, _unref(controle).erro != '']
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).retornos, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: _normalizeClass(item.retornoId == _unref(controle).retornoId ? 'table-active' : ''),
                    onClick: ($event: any) => {_unref(controle).retornoId = item.retornoId; _unref(controle).retorno = item}
                  }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(item.retornoId), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(fdataHora)(item.dataCadastro)), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(item.cedenteCodigo), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(item.cedenteCpfCnpj), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.numero), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.numeroArquivo), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.qtdeItens), 1),
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(RetornoStatus, {
                        status: item.status
                      }, null, 8, ["status"])
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createVNode(_component_RouterLink, {
                        class: "btn btn-sm btn-primary me-1",
                        to: '/boletosRetornosItens/' + item.retornoId,
                        title: "Exibir detalhes do retorno"
                      }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]),
                      (item.status != 2)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-sm btn-warning me-1",
                            title: "Processar retorno",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (perguntaProcessar(item)),
                            disabled: _unref(controle).processandoRetorno
                          }, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("i", { class: "fa fa-play" }, null, -1)
                          ]))], 8, _hoisted_25))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_15))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("a", {
              class: "btn btn-sm btn-primary me-2",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(controle).janImportarRetorno = true)),
              title: "Importar arquivo de retorno do banco"
            }, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("i", { class: "fa fa-download" }, null, -1),
              _createTextVNode(" Importar Retorno ", -1)
            ]))]),
            _createElementVNode("span", _hoisted_29, "Total: " + _toDisplayString(_unref(controle).totalRegistros) + " registro(s)", 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina,
              totalRegistros: _unref(controle).totalRegistros,
              onOnChange: _cache[12] || (_cache[12] = (el) => {
                            _unref(controle).filtros.paginaAtual = el.paginaAtual;
                            _unref(controle).filtros.tamanhoPagina = el.tamanhoPagina;
                            pesquisar()
                        })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-sm btn-primary me-1 float-end",
              to: "/boletos",
              title: "Fechar"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode(" Fechar ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(Pergunta, {
      exibir: _unref(controle).showConfirmDialog,
      titulo: "Processar Retorno",
      mensagem: `Deseja processar o retorno ${_unref(controle).retornoParaProcessar?.retornoId}?`,
      detalhes: _unref(controle).retornoParaProcessar ? `Arquivo: ${_unref(controle).retornoParaProcessar.numero} | Itens: ${_unref(controle).retornoParaProcessar.qtdeItens}` : '',
      tipo: "warning",
      textoSim: "Processar",
      textoNao: "Cancelar",
      processando: _unref(controle).processandoRetorno,
      onResposta: confirmaProcessar
    }, null, 8, ["exibir", "mensagem", "detalhes", "processando"]),
    _createVNode(ImportarRetorno, {
      exibir: _unref(controle).janImportarRetorno,
      onFechou: _cache[13] || (_cache[13] = ($event: any) => (_unref(controle).janImportarRetorno = false)),
      onImportou: _cache[14] || (_cache[14] = ($event: any) => (pesquisar()))
    }, null, 8, ["exibir"])
  ], 64))
}
}

})